import FellingWords from '../../statics/felling-words.json';

export const fellingWords = {
  keyArgs: false,
  read() {
    return FellingWords;
  }
};
